import { Module } from '@nestjs/common'
import { UserController } from './controllers'
import { UserService } from './services'

@Module({
	controllers: [UserController],
	providers: [UserService],
})
export class UserModule {}
